// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh2[data-v-09dfe088]{ color: var(--main-gray-6);\n}\np[data-v-09dfe088]{\n  margin: 0 0 20px 0 !important;\n  padding: 0 0 0 0;\n  color: var(--main-gray-6);\n  line-height: 22px;\n}\na.w-button[data-v-09dfe088]{ text-decoration: none;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
